import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const patientEligibilityVerificationService = {
  basePath: organizationId =>
    `${clinicalApiPath}/organizations/${organizationId}/patient-eligibility-verifications`,

  save(orgId, verification) {
    return viperApi.post(this.basePath(orgId), verification)
  }
}
